// src/pixel.js

// Handle both ESM and CJS builds of the library
import ReactPixelImport from "react-facebook-pixel";
const ReactPixel = ReactPixelImport?.default || ReactPixelImport;

const options = {
  autoConfig: true,
  debug: false, // set true to see console logs
};

// optional: only enable in production
const isProd = process.env.NODE_ENV === "production";

export const initPixel = () => {
  // skip if fbq blocked or in dev (remove the isProd check if you want it in dev too)
  if (typeof window === "undefined" /* SSR guard */) return;
  // if (!isProd) return;

  try {
    ReactPixel.init("2812822652235621", options);
    ReactPixel.pageView(); // initial page load
  } catch (e) {
    // helpful debug if the package exports are odd
    // eslint-disable-next-line no-console
    console.warn("[Pixel] init failed:", e, { ReactPixelImport, ReactPixel });
  }
};

export const trackPageView = () => {
  try {
    ReactPixel.pageView();
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn("[Pixel] pageView failed:", e);
  }
};

export const trackEvent = (eventName, params) => {
  try {
    ReactPixel.track(eventName, params);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn("[Pixel] track failed:", e, { eventName, params });
  }
};

export const trackCustomEvent = (eventName, params) => {
  try {
    ReactPixel.trackCustom(eventName, params);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn("[Pixel] trackCustom failed:", e, { eventName, params });
  }
};
